import { Observable, Subscription } from 'rxjs/Rx';
import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { TimerObservable } from "rxjs/observable/TimerObservable";
import { JwtHelper } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { TimerService } from "./timer.service";

declare var jQuery: any;
@Component({
    selector: 'timer',
    template: '<span>{{message}}</span>'
})

export class TimerComponent implements OnInit {
    private future: Date;
    private diff: number;
    message: any;
    token: string;
    jwtHelper: JwtHelper = new JwtHelper();
    @Input('inputtoken') token1: string;

    constructor(private sessionStorageService: SessionStorageService, private timerService: TimerService, private elm: ElementRef) {
    }

    dhms(t) {
        var days, hours, minutes, seconds;
        days = Math.floor(t / 86400);
        t -= days * 86400;
        hours = Math.floor(t / 3600) % 24;
        t -= hours * 3600;
        minutes = Math.floor(t / 60) % 60;
        t -= minutes * 60;
        seconds = t % 60;

        return [
            days + 'd',
            hours + 'h',
            minutes + 'm',
            seconds + 's'
        ].join(' ');
    }


    ngOnInit() {
        jQuery(".root").attr("inputtoken", this.sessionStorageService.retrieve("Token"));
        let token = jQuery(".root").attr("inputtoken");
        this.future = new Date(this.jwtHelper.getTokenExpirationDate(token).toString());
        this.timerService.consultaTimer(token).subscribe(result => {
            this.token = result.toString();
            Observable.interval(1000).map((x) => {
                this.diff = Math.floor((this.future.getTime() - new Date().getTime()) / 1000);
            }).subscribe((x) => {
                this.message = this.dhms(this.diff);
            });
        })
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/components/common/timer/timer.component.ts